exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-workspace-quick-filter{display:inline-block;max-width:220px;margin:0 20px 0 0}", ""]);

// exports
